// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbarStyles_toolbar__aN5g-"};